import { render } from "./leftMenuBlock.vue?vue&type=template&id=6b877fec"
import script from "./leftMenuBlock.vue?vue&type=script&lang=js"
export * from "./leftMenuBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__